<template>
  <!-- Modal tapu -->
  <div
    class="modal fade"
    id="how-to-choose-modal"
    ref="howToChooseModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="how-to-choose-modal"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="how-to-choose-modal">Hangi şirket türünü seçmeliyim?</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <iframe
            width="560"
            height="315"
            class="full-width"
            :src="vid"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn_1" data-dismiss="modal">Kapat</button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'HowToChooseModal',
  data() {
    return {
      vid: 'https://www.youtube.com/embed/vcvmS-up98s',
    };
  },
  methods: {
    setVideo() {
      this.vid = 'https://www.youtube.com/embed/vcvmS-up98s';
    },
    closeVideo() {
      this.vid = '';
    },
  },
  mounted() {
    $(this.$refs.howToChooseModal).on('hidden.bs.modal', this.closeVideo);
    $(this.$refs.howToChooseModal).on('shown.bs.modal', this.setVideo);
  },
};
</script>
